import { ContactReferrerArrangement } from '@features/contacts/models';
import {
  NumberPropertyDefinition,
  StringPropertyDefinition
} from '@shared/models/schema-property-definition';

export namespace LeadReferrerArrangement {
  export interface SchemaPropertyDefinition {
    payeeName: StringPropertyDefinition;
    upfront: {
      amount: NumberPropertyDefinition;
      percent: NumberPropertyDefinition;
    };
    trail: NumberPropertyDefinition;
  }

  export interface SchemaContract {
    payeeName?: string | null;
    upfront?:
      | {
          amount: number | null;
        }
      | {
          percent: number | null;
        }
      | null;
    trail?: number | null;
  }

  export interface Model {
    payeeName: string | null;
    upfront: {
      type: ContactReferrerArrangement.UpfrontType | null;
      amount: number | null;
      percent: number | null;
    };
    trail: number | null;
  }

  export function toModel(
    value?: LeadReferrerArrangement.SchemaContract | null
  ): LeadReferrerArrangement.Model | null {
    if (!value?.payeeName) {
      return null;
    }
    return {
      payeeName: value.payeeName,
      upfront: value.upfront
        ? {
            type:
              'amount' in value.upfront
                ? ContactReferrerArrangement.UpfrontType.Amount
                : ContactReferrerArrangement.UpfrontType.Percent,
            amount: 'amount' in value.upfront ? value.upfront.amount : null,
            percent: 'percent' in value.upfront ? value.upfront.percent : null
          }
        : {
            type: null,
            amount: null,
            percent: null
          },
      trail: value.trail || null
    };
  }

  export function toSchemaContract(
    value: LeadReferrerArrangement.Model | null
  ): LeadReferrerArrangement.SchemaContract {
    if (!value) {
      return {};
    }
    return {
      payeeName: value.payeeName,
      upfront:
        value.upfront.type === ContactReferrerArrangement.UpfrontType.Amount
          ? {
              amount: value.upfront.amount
            }
          : value.upfront.type ===
            ContactReferrerArrangement.UpfrontType.Percent
          ? {
              percent: value.upfront.percent
            }
          : null,
      trail: value.trail
    };
  }
}
